<template>
	<transition name="fade">
		<div class="modal df fdc jcsb" :class="data.type=='pc'?'pc':'h5'" v-show="show">
			<div class="title df aic jcc py-1">{{data.title}}</div>
			<div class="df aic jcsb wm por bottom">
				<div class="img">
					<img style="object-fit:scale-down" v-lazy="data.img" width="100%" height="100%" alt="">
				</div>
				<div class="df fdc jcsb hm info">
					<div class="desc t0 poa" v-html="data.introduce"></div>
					<div class="src df aic poa b0 jcc py-1" @click="go">查看详情</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'modal',
		data() {
			return {

			}
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			data: {
				type: Object,
				default: () => ({})
			}
		},
		methods: {
			go() {
				open(this.data.url, '_blank')
			},
		}
	}
</script>

<style lang="scss" scoped>
	.fade-enter {
		opacity: 0;
		transform: scale(1.5);
	}

	.fade-enter-active {
		transition: all .5s linear;
	}

	.fade-enter-to {
		transform: scale(1);
	}

	.fade-leave {
		transform: rotateY(0deg) scale(1);
		opacity: 1;
	}

	.fade-leave-active {
		transition: all .8s linear;
	}

	.fade-leave-to {
		transform: rotateY(180deg) scale(0.1);
	}

	.pc {
		width: 80%;
		top: 20%;
		left: 10%;

		.title {
			width: 50%;
			height: 15%;
		}

		.bottom {
			margin-top: 1%;

			.img {
				width: 60%;
			}

			.info {
				width: 35%;

				.src {
					width: 35%;
					height: 15%;
				}

				.desc {
					width: 35%;
					height: 75%;
				}
			}
		}


	}

	.h5 {
		width: 35%;
		top: 10%;
		left: 30%;

		.title {
			width: 100%;
			height: 10%;
		}

		.bottom {
			margin-top: 3%;

			.img {
				width: 45%;
			}

			.info {
				width: 50%;

				.src {
					width: 50%;
				}

				.desc {
					width: 50%;
					height: 75%;
				}
			}
		}


	}

	.modal {
		padding: 20px;
		position: absolute;
		background: rgba(0, 127, 127, 0.5);
		border: 1px solid rgba(127, 255, 255, 0.25);
		box-shadow: 0 0 12px rgba(0, 255, 255, 0.5);
		border-radius: 3px;
		transition: transform 1s;
		font-weight: bold;
		color: rgba(127, 255, 255, 0.75);

		.title,
		.img,
		.src,
		.desc {
			background: rgba(0, 0, 0, 0.5);
			border-radius: 3px;
			border: 1px solid rgba(127, 255, 255, 0.25);
			box-shadow: 0 0 12px rgba(0, 255, 255, 0.5);
		}

		.title {
			margin: 0 auto;
			font-size: 20px;
			text-shadow: 0 0 5px rgba(0, 255, 255, 0.5);
		}

		.img {
			padding: 4px;
			padding-bottom: 0;
		}

		.src {
			cursor: pointer;
			user-select: none;

			&:active {
				color: #fff;
				box-shadow: 0 0 12px rgba(255, 255, 255, 1);
			}
		}

		.desc {
			padding: 10px;
			overflow-y: auto;

			&::-webkit-scrollbar {
				width: 0 !important
			}
		}
	}
</style>
